import { track } from "@amplitude/analytics-browser";
import { HiMagnifyingGlass } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";

const SearchBar = () => {
  const navigate = useNavigate();

  return (
    <div className="flex-1 relative w-full">
      <div
        onClick={() => {
          track("홈 검색바 클릭");
          navigate("/search", { state: { from: "/" } });
        }}
        className="w-full h-12 pl-4 pr-12 rounded-3xl bg-white flex items-center cursor-pointer active:bg-gray-50 transition-colors border border-gray-300"
      >
        <span className="text-gray-500 text-md break-keep">
          매장 이름, 주소를 검색해보세요
        </span>
      </div>
      <button className="absolute right-3 top-1/2 -translate-y-1/2 p-1.5 active:bg-gray-100 rounded-full transition-colors">
        <HiMagnifyingGlass className="w-5 h-5 text-gray-500" />
      </button>
    </div>
  );
};

export default SearchBar;
